import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { useLang } from "@/i18n/LanguageContext";

const PLACEHOLDER =
  "https://images.unsplash.com/photo-1518611540400-6b85a0704342?w=800&q=60";

export const PersonCard = ({ person, index }) => {
  const { tc, t } = useLang();
  const date = person.created_at
    ? new Date(person.created_at).toISOString().slice(0, 10)
    : "";
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.06, ease: [0.76, 0, 0.24, 1] }}
    >
      <Link
        to={`/person/${person.id}`}
        className="group relative block border-r border-b border-border bg-card"
        data-testid={`person-card-${person.id}`}
      >
        {/* Image */}
        <div className="relative aspect-[4/5] overflow-hidden bg-secondary">
          <img
            src={person.photo || PLACEHOLDER}
            alt={person.full_name}
            className="portrait-img h-full w-full object-cover"
            loading="lazy"
            onError={(e) => (e.currentTarget.src = PLACEHOLDER)}
          />
          {/* crosshair corners */}
          <span className="pointer-events-none absolute left-3 top-3 h-4 w-4 border-l-2 border-t-2 border-accent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
          <span className="pointer-events-none absolute right-3 bottom-3 h-4 w-4 border-r-2 border-b-2 border-accent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
          <div className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center bg-foreground text-background opacity-0 transition-all duration-300 group-hover:opacity-100">
            <ArrowUpRight size={16} weight="bold" />
          </div>
          <span className="absolute left-3 bottom-3 font-mono text-[10px] uppercase tracking-[0.2em] text-background bg-foreground px-2 py-1">
            {t("card.sev")} {person.severity}/5
          </span>
        </div>
        {/* Meta */}
        <div className="p-5 space-y-3">
          <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            <span className="border border-border px-2 py-0.5 text-foreground">
              {tc(person.category)}
            </span>
            <span>{date}</span>
          </div>
          <h3 className="font-display font-extrabold uppercase tracking-tight leading-none text-xl group-hover:text-primary transition-colors">
            {person.full_name}
          </h3>
          <p className="font-mono text-xs leading-relaxed text-muted-foreground line-clamp-2">
            {person.description}
          </p>
        </div>
      </Link>
    </motion.div>
  );
};
